import { browser, dev } from '$app/environment';

const Log = {
	async error(message: string, data?: Record<string, unknown>) {
		console.error(message, data);
		if (dev) return;
		(await getLogger()).error(message, data);
	},

	async debug(message: string, data?: Record<string, unknown>) {
		console.debug(message, data);
		// if (!dev) return;
		// (await getLogger()).debug(message, data);
	},

	async info(message: string, data?: Record<string, unknown>) {
		console.info(message, data);
		if (dev) return;
		(await getLogger()).info(message, data);
	},

	async warning(message: string, data?: Record<string, unknown>) {
		console.warn(message, data);
		if (dev) return;
		(await getLogger()).warning(message, data);
	}
};

export async function getLogger() {
	if (browser) {
		return (await import('$lib/logging/client-logger')).ClientLogger;
	} else {
		return (await import('$lib/logging/server-logger')).ServerLogger;
	}
}

export default Log;
